import React, { Component } from 'react';
import { Consumer } from '../../Modal';

class TopicList extends Component {
  isInRange = this.props.isInRange;
  topic = React.createRef();

  isTopicInRange(container) {
    const top = this.getBoundingClientRectHandler().top - container.scrollTop;
    const bottom =
      this.getBoundingClientRectHandler().bottom - container.scrollTop;

    if (top < 1 && bottom > 0 && !this.isInRange) {
      this.props.setCurrentActiveLetter(this.props.letter);
      this.isInRange = true;
    } else {
      this.isInRange = false;
    }
  }

  getBoundingClientRectHandler() {
    return {
      bottom: this.topic.current.offsetTop + this.topic.current.clientHeight,
      top: this.topic.current.offsetTop,
    };
  }

  enterHandler(e) {
    if (e.keyCode === 13) {
      this.props.returnToAlphabetic();
    }
  }

  enterHandlerClose(e) {
    if (e.keyCode === 13) {
      e.preventDefault();
      e.currentTarget.click();
    }
  }

  componentDidMount() {
    this.props.addTopicListToHandles(this);
  }

  render() {
    const props = this.props;

    const topicList =
      props.categories &&
      props.categories.map((topic, index) => {
        return (
          <Consumer key={`${topic.CategoryName}--${index}`}>
            {({ closeModal, activeModalId }) => (
              <li className="categories-topic-list__item">
                <label
                  onKeyDown={(e) => this.enterHandlerClose(e)}
                  className="categories-topic-list__item-label"
                  tabIndex="0"
                >
                  <input
                    tabIndex="-1"
                    type="radio"
                    name="caretype-list"
                    defaultChecked={
                      topic.CategoryName === props.selectedCareType
                    }
                    onChange={() => {
                      props.careTypeChangeHandler(topic.CategoryName.trim());
                      closeModal(activeModalId);
                    }}
                    value={topic.CategoryName.trim()}
                  />
                  {topic.CategoryName}
                </label>
              </li>
            )}
          </Consumer>
        );
      });

    return (
      <div
        className="categories-topic-list__wrapper"
        ref={this.topic}
        id={props.letter}
      >
        <div className="categories-topic-list__heading">
          <h3>{props.letter.toUpperCase()}</h3>
        </div>
        <ul className="categories-topic-list">
          {topicList}
          <li className="categories-topic-list__item categories-topic-list__item--focus-only">
            <label
              className="categories-topic-list__item-label categories-topic-list__item-label--focus-only"
              tabIndex="0"
              onKeyDown={(e) => this.enterHandler(e)}
              onClick={(e) => this.enterHandler(e)}
            >
              Tillbaka till alfabetisk lista
            </label>
          </li>
        </ul>
      </div>
    );
  }
}

export default TopicList;
